module.exports = __webpack_public_path__ + "img/service_350x500_3.d420d47c.jpg";